import {
  userExpress,
  userExpressCreate,
  currentUserExpress,
  userExpressUpdate,
  campaign,
  campaignCreate,
  currentCampaign,
  updatecurrentCampaign,
  campaignHistoryInitialize,
  campaignsHistory,
  campaignHistoryUpdate,
  tmpLocationOpeningHours,
  tmpLocationExceptionalOpeningHours,
  campaignSubmit,
} from '@/services/userexpress.service'
import { tableOptions } from '@/utils/table.util'

const SET_USER_EXPRESS = 'SET_USER_EXPRESS'
const SET_USER_EXPRESS_MOBILE = 'SET_USER_EXPRESS_MOBILE'
const SET_USER_EXPRESS_PAGINATION = 'SET_USER_EXPRESS_PAGINATION'
const SET_CURRENT_USER_EXPRESS = 'SET_CURRENT_USER_EXPRESS'
const UPDATE_CURRENT_USER_EXPRESS = 'UPDATE_CURRENT_USER_EXPRESS'
const SET_CAMPAIGN = 'SET_CAMPAIGN'
const SET_CAMPAIGN_MOBILE = 'SET_CAMPAIGN_MOBILE'
const SET_CAMPAIGN_PAGINATION = 'SET_CAMPAIGN_PAGINATION'
const SET_CURRENT_CAMPAIGN = 'SET_CURRENT_CAMPAIGN'
const SET_CAMPAIGNS_HISTORY = 'SET_CAMPAIGNS_HISTORY'
const UPDATE_CAMPAIGN_HISTORY = 'UPDATE_CAMPAIGN_HISTORY'
const CLEAR_CAMPAIGN_HISTORY = 'CLEAR_CAMPAIGN_HISTORY'
const SET_TMP_LOCATION_OPENING_HOURS = 'SET_TMP_LOCATION_OPENING_HOURS'
const SET_TMP_LOCATION_EXCEPTIONAL_OPENING_HOURS = 'SET_TMP_LOCATION_EXCEPTIONAL_OPENING_HOURS'
const RESET_STATE = 'RESET_STATE'

const getDefaultState = () => {
  return {
    userExpress: [],
    userExpressMobile: [],
    userExpressPagination: {},
    currentUserExpress: {},
    campaign: [],
    campaignMobile: [],
    campaignPagination: {},
    currentCampaign: {},
    campaignsHistory: [],
    tmpLocationOpeningHours: [],
    tmpLocationExceptionalOpeningHours: [],
  }
}

const state = getDefaultState()

const mutations = {
  [SET_USER_EXPRESS]: (state, userExpress) => {
    state.userExpress = userExpress
  },
  [SET_USER_EXPRESS_MOBILE]: (state, { userExpress, reset }) => {
    if (reset) {
      state.userExpressMobile = []
    }
    state.userExpressMobile.push(...userExpress)
  },
  [SET_USER_EXPRESS_PAGINATION]: (state, pagination) => {
    state.userExpressPagination = pagination
  },
  [SET_CURRENT_USER_EXPRESS]: (state, userExpress) => {
    state.currentUserExpress = userExpress
  },
  [UPDATE_CURRENT_USER_EXPRESS]: (state, updatedUserExpress) => {
    state.currentUserExpress = updatedUserExpress
  },
  [SET_CAMPAIGN]: (state, campaign) => {
    state.campaign = campaign
  },
  [SET_CAMPAIGN_MOBILE]: (state, { campaign, reset }) => {
    if (reset) {
      state.campaignMobile = []
    }
    state.campaignMobile.push(...campaign)
  },
  [SET_CAMPAIGN_PAGINATION]: (state, pagination) => {
    state.campaignPagination = pagination
  },
  [SET_CURRENT_CAMPAIGN]: (state, campaign) => {
    state.currentCampaign = campaign
  },
  [SET_CAMPAIGNS_HISTORY]: (state, history) => {
    state.campaignsHistory = history
  },
  [UPDATE_CAMPAIGN_HISTORY]: (state, history) => {
    state.campaignHistory = state.campaignHistory.map(h => {
      if (h.id === history.id) return history
      return h
    })
  },
  [CLEAR_CAMPAIGN_HISTORY]: state => {
    state.campaignHistory = []
  },
  [SET_TMP_LOCATION_OPENING_HOURS]: (state, openingHours) => {
    state.tmpLocationOpeningHours = openingHours
  },
  [SET_TMP_LOCATION_EXCEPTIONAL_OPENING_HOURS]: (state, exceptionalOpeningHours) => {
    state.tmpLocationExceptionalOpeningHours = exceptionalOpeningHours
  },
  [RESET_STATE]: state => {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  getUserExpress: ({ commit, rootState }, { tableParams, resetUserExpress }) => {
    const urlParams = tableOptions(tableParams, '', 'userExpress')
    return userExpress(rootState.client.currentClient.id, urlParams)
      .then(response => {
        commit(SET_USER_EXPRESS, response.data.results)
        commit(SET_USER_EXPRESS_MOBILE, { userExpress: response.data.results, reset: resetUserExpress })
        delete response.data.results
        commit(SET_USER_EXPRESS_PAGINATION, response.data)
        return Promise.resolve()
      })
      .catch(e => Promise.reject(e))
  },
  createUserExpress: ({ rootState }, { lastName, firstName, email, locations }) => {
    const data = {
      clientId: rootState.client.currentClient.id,
      administratorId: rootState.backoffice.currentUser.id || rootState.backoffice.currentUser.uuid,
      firstName,
      lastName,
      email,
      locations,
    }
    return userExpressCreate(rootState.client.currentClient.id, data)
      .then(response => {
        return Promise.resolve(response.data)
      })
      .catch(e => Promise.reject(e))
  },
  getCurrentUserExpress: ({ commit, rootState }, { userExpressId, administratorId }) => {
    return currentUserExpress(userExpressId, rootState.client.currentClient.id, administratorId)
      .then(response => {
        commit(SET_CURRENT_USER_EXPRESS, response.data)
        return Promise.resolve()
      })
      .catch(e => Promise.reject(e))
  },
  updateUserExpress: ({ commit, rootState }, data) => {
    if (data.locations) {
      data.locations = data.locations.map(location => location.id)
    } else {
      data.locations = rootState.userexpress.currentUserExpress.locations.map(location => location.id)
    }
    const newCurrentUserExpress = Object.assign({ ...rootState.userexpress.currentUserExpress }, data)
    return userExpressUpdate(
      rootState.userexpress.currentUserExpress.id,
      rootState.client.currentClient.id,
      newCurrentUserExpress
    )
      .then(response => {
        commit(UPDATE_CURRENT_USER_EXPRESS, response.data)
        return Promise.resolve()
      })
      .catch(e => Promise.reject(e))
  },
  getCampaign: ({ commit, rootState }, { resetCampaign, tableParams, search }) => {
    const urlParams = tableOptions(tableParams, search, 'userExpress')
    return campaign(rootState.client.currentClient.id, urlParams)
      .then(response => {
        commit(SET_CAMPAIGN, response.data.results)
        commit(SET_CAMPAIGN_MOBILE, { campaign: response.data.results, reset: resetCampaign })
        delete response.data.results
        commit(SET_CAMPAIGN_PAGINATION, response.data)
        return Promise.resolve()
      })
      .catch(e => Promise.reject(e))
  },
  async createCampaign({ rootState }, { userExpressId, userExpressLocations }) {
    const clientId = rootState.client.currentClient.id
    const dataCampaign = {
      administratorId: rootState.backoffice.currentUser.id || rootState.backoffice.currentUser.uuid,
      clientId,
      userExpressId,
    }
    const response = await campaignCreate(clientId, dataCampaign)
    const promises = userExpressLocations.map(location => {
      const dataHistory = {
        administratorId: rootState.backoffice.currentUser.id || rootState.backoffice.currentUser.uuid,
        userExpressUpdateCampaignId: response.data.id,
        locationId: location.id,
        clientId,
        status: 'waiting',
      }
      return campaignHistoryInitialize(clientId, dataHistory)
    })
    await Promise.all(promises)
  },
  updateCurrentCampaign: ({ dispatch, rootState }, { payload, filters, isAuthorize }) => {
    return updatecurrentCampaign(payload.id, rootState.client.currentClient.id, payload.data)
      .then(() => {
        dispatch('getCampaign', { resetCampaign: true, tableParams: { filters }, isAuthorize })
        return Promise.resolve()
      })
      .catch(e => Promise.reject(e))
  },
  getCurrentCampaign: ({ commit, rootState }, { campaignId, administratorId }) => {
    return currentCampaign(campaignId, administratorId, rootState.client.currentClient.id)
      .then(response => {
        commit(SET_CURRENT_CAMPAIGN, response.data)
        return Promise.resolve()
      })
      .catch(e => Promise.reject(e))
  },
  getCampaignsHistory: ({ commit }, { campaignId, administratorId }) => {
    commit(CLEAR_CAMPAIGN_HISTORY)
    return campaignsHistory(administratorId, campaignId)
      .then(response => {
        commit(SET_CAMPAIGNS_HISTORY, response.data)
        return Promise.resolve()
      })
      .catch(e => Promise.reject(e))
  },
  submitCampaign: ({ state, commit }, { action, comment = null, history }) => {
    const dataSubmit = {
      administratorId: state.currentUserExpress.administratorId,
      userExpressId: state.currentUserExpress.id,
      status: action === 'accept' ? 'validated' : 'rejected',
      comment,
      token: state.currentCampaign.token,
    }
    const dataHistory = {
      ...history,
      status: action === 'accept' ? 'validated' : 'rejected',
      comment,
    }
    return campaignSubmit(
      state.currentUserExpress.administratorId,
      action,
      history.userExpressUpdateCampaignId,
      history.locationId,
      dataSubmit
    )
      .then(() => {
        return campaignHistoryUpdate(
          state.currentUserExpress.administratorId,
          history.id,
          history.locationId,
          dataHistory
        )
      })
      .then(response => {
        commit(UPDATE_CAMPAIGN_HISTORY, response.data)
        return Promise.resolve(response.data)
      })
      .catch(e => Promise.reject(e))
  },
  getTmpLocationOpeningHours: ({ commit }, locationId) => {
    return tmpLocationOpeningHours(locationId)
      .then(response => {
        commit(SET_TMP_LOCATION_OPENING_HOURS, response.data.results)
        return Promise.resolve()
      })
      .catch(e => Promise.reject(e))
  },
  getTmpLocationExceptionalOpeningHours: ({ commit }, locationId) => {
    return tmpLocationExceptionalOpeningHours(locationId)
      .then(response => {
        commit(SET_TMP_LOCATION_EXCEPTIONAL_OPENING_HOURS, response.data)
        return Promise.resolve()
      })
      .catch(e => Promise.reject(e))
  },
  resetState({ commit }) {
    commit(RESET_STATE)
  },
}

const getters = {
  userExpressFilteredActive: state => {
    let filteredUserExpress = []
    state.userExpress.forEach(ue => {
      if (ue.campaignActive === true) {
        filteredUserExpress.push(ue)
      }
    })
    return filteredUserExpress
  },
  userExpressFilteredDeactivate: state => {
    let filteredUserExpress = []
    state.userExpress.forEach(ue => {
      if (ue.campaignActive === false) {
        filteredUserExpress.push(ue)
      }
    })
    return filteredUserExpress
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
